import {
  IEquipmentCategoryItem,
  IEquipmentSubcategoryItem,
  IStageEquipmentCategory,
} from "Venues/types";
import React, { useMemo } from "react";
import { Card, FormBuilder } from "shared/components";
import { IAPIState, ICardTheme, IFormButtons } from "shared/types";

import { useStagePageContext } from "Venues/contexts";
import { VENUE_PATHS } from "Venues/router";
import { useVenueRoute } from "Venues/utils";
import { makeSchema } from "./formData";
import { copy } from "shared/assets";

interface EquipmentCategoryFormProps {
  category: IEquipmentCategoryItem | IEquipmentSubcategoryItem;
  apiStatus?: IAPIState;
  hasError?: boolean;
  handleSubmit: (data: IStageEquipmentCategory) => void;
  closeForm?: () => void;
}

export const EquipmentCategoryForm: React.FC<EquipmentCategoryFormProps> = ({
  category,
  apiStatus,
  hasError,
  children,
  handleSubmit,
  closeForm,
}) => {
  const { pushRoute } = useVenueRoute();
  const { stageId } = useStagePageContext();

  const formData = useMemo(
    () => makeSchema(category, closeForm),
    [category, closeForm]
  );

  const buttons: { buttons: IFormButtons } | undefined = useMemo(
    () =>
      closeForm
        ? undefined
        : {
            buttons: {
              secondary: {
                onClick: () =>
                  pushRoute(VENUE_PATHS.STAGE, {
                    stageId: stageId || "",
                  }),
                children: copy.form.cancel,
              },
            },
          },
    [closeForm, pushRoute, stageId]
  );

  const onSubmit = (data: { [key: string]: IStageEquipmentCategory }) => {
    handleSubmit({
      text: data[category.category].text || null,
      category: category.category,
    });
  };

  return (
    <Card theme={ICardTheme.secondary} size="m">
      <FormBuilder
        {...formData}
        onSubmit={onSubmit}
        submitMode="isDirty"
        isSubmitting={apiStatus === IAPIState.pending}
        apiErrorMessage={hasError}
        showSaveChanges={true}
        {...buttons}
      >
        {children}
      </FormBuilder>
    </Card>
  );
};
